import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type OptionBadgeType = 'purple' | 'gray' | 'aqua';

@Component({
  selector: 'option-full-badge',
  templateUrl: './option-full-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionFullBadgeComponent {
  @Input() title: string;
  @Input() img: string;
  @Input() description: string;
  @Input() type: OptionBadgeType;
}
